import requestUtils from "../request_util";
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    retryTime: 0,
    //生成任务基本数据
    baseTaskDetails(task) {
        var detail = {
            //任务id
            id: task.groupId?task.groupId:task.id,
            //任务名称
            name: task.name,
            //创建时间
            createTime: task.createTime,
            //来源集合
            fromItem: this.convertFromOrToSource(null,task.fromItem),
            //目标集合
            toItem: this.convertFromOrToSource(null,task.toItem),
            //任务状态
            status: this.convertStatus(task),
            //任务设置
            options: task.options,
        }

        //标记组任务
        if(task.groupId) {
            //组任务自动合并,使用组id
            detail.isMultiTask = true;
        }

        //任务进度查询id
        if(task.workId) {
            detail.workId = task.workId;
        }

        //任务定时信息
        if(task.schedules){
            detail.schedules = task.schedules;
            if(task.schedules.type == 'Now' && task.schedules.disabled == undefined) {
                detail.schedules.disabled = true;
            }
        }else {
            //如果没有定时信息，默认不启动定时
            detail.schedules = {
                disabled: true
            }
        }

        //任务tranferWay
        if(task.tranferWay) {
            detail.tranferWay = task.tranferWay;
        }

        return detail;
    },
    //传输任务详情数据转化
    transferTaskDetails(task) {
        //生成基本任务数据
        var detail = this.baseTaskDetails(task);

        //任务类型
        detail.type = 1;

        //任务下级类型
        if(task.options.way=="cloudEmail"){
            //邮件传输任务类型为106
            detail.lowerType = 106;
            detail.icon = 'emailTransfer';
        }else {
            //普通传输任务
            detail.lowerType = 101;
            detail.icon = 'cloudTransfer';
        }
        
        //任务结束状态
        if(detail.status == 0){
            //正常结束状态
            detail.result = this.convertResult(task);
            detail.lastLog = task.lastLog;
        }
        return detail;
    },
    //企业传输任务详情数据转化
    businessTaskDetails(task) {
        var dataBusiness = task.businessTask;
        var transferTasks = task.transferTasks;
        if(!task.businessTask) {
            dataBusiness = task;
        }
        //生成基本任务数据
        var detail = this.baseTaskDetails(dataBusiness);

        //任务类型
        detail.type = 1;
        detail.lowerType = 104;
        detail.icon = 'teamTransfer';
        if(transferTasks&&transferTasks.length>0) {
            detail.sources = transferTasks;
            detail.options = transferTasks[0].options;
        }
        
        // if(task.transferTasks&&task.transferTasks[0]) {
        //     //添加多目标参数
        //     task.transferTasks.forEach(item => {
        //         detail.toItem = this.convertFromOrToSource(detail.toItem,item.toItem);
        //     });
        // }

        if(transferTasks.length>1) {
            detail.isMultiTask = true;
        }

        detail.status = this.convertStatus(detail);
        
        if(detail.status == 0){
            //正常结束状态
            detail.result = this.convertResult(dataBusiness);
            detail.lastLog = dataBusiness.lastLog;
        }
        return detail;
    },
    //同步任务详情数据转化
    syncTaskDetails(task) {
        //生成基本任务数据
        var detail = this.baseTaskDetails(task);

        //任务类型
        detail.type = 2;
        detail.lowerType = 102;
        detail.icon = 'cloudsync';
        
        if(detail.status == 0){
            //正常结束状态
            detail.result = this.convertResult(task);
            detail.lastLog = task.lastLog;
        }

        return detail;
    },
    //离线下载任务详情数据转化
    offlinesTaskDetails(task) {
        //离线任务需要自行组装源数据
        task.fromItem = {
            driveType: 'offlinesTask',
            name: task.url,
            isDir: false,
            nodes: [{fileName: task.url}]
        };

        //生成基本任务数据
        var detail = this.baseTaskDetails(task);

        //任务类型
        detail.type = task.type;
        detail.lowerType = 105;
        detail.icon = 'linkTask';
        
        if(detail.status == 0){
            //正常结束状态
            detail.result = this.convertResult(task);
            detail.lastLog = task.lastLog;
        }
        return detail;
    },
    //备份任务详情数据转化
    backupTaskDetails(task) {
        //生成基本任务数据
        var detail = this.baseTaskDetails(task);

        //任务类型
        detail.type = 6;
        detail.lowerType = 103;
        detail.icon = 'cloudbackup';
        
        if(detail.status == 0){
            //正常结束状态
            detail.result = this.convertResult(task);
            detail.lastLog = task.lastLog;
        }

        //标记组任务
        if(task.fromItem.data) {
            detail.isMultiTask = true;
            var fromItem;
            task.fromItem.data.forEach(item => {
                fromItem = this.convertFromOrToSource(fromItem,item);
            });
            detail.fromItem = fromItem;
        }
        if(task.toItem.data) {
            detail.isMultiTask = true;
            var toItem;
            task.toItem.data.forEach(item => {
                toItem = this.convertFromOrToSource(toItem,item);
            });
            detail.toItem = toItem;
        }
        //标记是否新位置
        if(task.toItem.isRestoreNew) {
            detail.isRestoreNew = true;
        }
        return detail;
    },
    //处理源和目标数据
    convertFromOrToSource(source,data) {
        if(!source) {
            source = {
                lists: [],
                icons: []
            }
        }
        source.lists.push(data);
        if(source.icons.length<11){
            const itemIndex = source.icons.findIndex(item => item.driveId == data.driveId);
            if(itemIndex == -1){
                //如果没有重复
                if(data.driveType == "offlinesTask") {
                    //如果是离线任务
                    let d;
                    if(data.name.substr(0, 7).toLowerCase() == "http://" || data.name.substr(0, 8).toLowerCase() == "https://") {
                        d = {
                            driveType: "offlinesUrl",
                        };
                    }else {
                        d = {
                            driveType: "offlinesBT",
                        };
                    }
                    source.icons.push(d);
                }else {
                    source.icons.push({
                        driveId: data.driveId,
                        driveType: data.driveType
                    });
                }
            }
        }
        return source;
    },
    //处理传输任务原始集合
    getTransferTasks(originTransferTasks) {
        let transferTasks = [];
        let transferGroupIds = {};//多源传输任务id和对应的index
        originTransferTasks.forEach(task => {
            if(task.groupId){
                //如果是多源任务，则尝试获取在transferGroupIds键值对中的值
                let taskIndex = transferGroupIds[task.groupId];
                if(taskIndex != undefined) {
                    //如果已存在该组任务，则添加到对应任务中
                    let groupTask = transferTasks[taskIndex];
                    //添加多源参数
                    if(task.fromItem){
                        groupTask.fromItem = this.convertFromOrToSource(groupTask.fromItem,task.fromItem);
                    }
                    //判断状态用，可删除
                    if(groupTask.sources) {
                        groupTask.sources.push(task);
                    }else {
                        groupTask.sources = [task];
                    }
                    transferTasks[taskIndex] = groupTask;
                }else {
                    //如果当前没有该组任务，则新增
                    task.fromItem = this.convertFromOrToSource(null,task.fromItem);
                    //添加组任务标记
                    taskIndex = transferTasks.length;
                    transferGroupIds[task.groupId] = taskIndex;
                    transferTasks.push(task);
                }
            }else {
                //新增单源传输任务
                transferTasks.push(this.transferTaskDetails(task));
            }
        });

        //计算组任务
        if(transferGroupIds) {
            var keys = Object.keys(transferGroupIds);
            keys.forEach(key => {
                let taskIndex = transferGroupIds[key];
                let newTask = this.transferTaskDetails(transferTasks[taskIndex]);
                newTask.fromItem = transferTasks[taskIndex].fromItem;
                newTask.sources = transferTasks[taskIndex].sources;
                transferTasks[taskIndex] = newTask;
            });
        }

        return transferTasks;
    },
    //处理企业传输任务原始集合
    getBusinessTasks(originBusinessTasks) {
        let businessTasks = [];
        console.log("businessTasks",originBusinessTasks)
        originBusinessTasks.forEach(task => {
            let businessDetail = this.businessTaskDetails(task);
            if(businessDetail) {
                businessTasks.push(businessDetail);
            }
        });
        return businessTasks;
    },
    //处理同步任务原始集合
    getSyncTasks(originSyncTasks,realTimeTasks) {
        let syncGroupIds = {};//多源传输任务id和对应的index
        let syncTasks = [];
        originSyncTasks.forEach(task => {
            if(task.groupId){
                //如果是多源任务，则尝试获取在transferGroupIds键值对中的值
                let taskIndex = syncGroupIds[task.groupId];
                if(taskIndex != undefined) {
                    //如果已存在该组任务，则添加到对应任务中
                    let groupTask = syncTasks[taskIndex];
                    //添加多源参数
                    if(task.toItem){
                        groupTask.toItem = this.convertFromOrToSource(groupTask.toItem,task.toItem);
                    }
                    //判断状态用，可删除
                    if(groupTask.sources) {
                        groupTask.sources.push(task);
                    }else {
                        groupTask.sources = [task];
                    }

                    syncTasks[taskIndex] = groupTask;
                }else {
                    //如果当前没有该组任务，则新增
                    //添加组任务标记
                    taskIndex = syncTasks.length;
                    task.toItem = this.convertFromOrToSource(null,task.toItem);
                    syncGroupIds[task.groupId] = taskIndex;
                    syncTasks.push(task);
                }
            }else {
                //新增单源传输任务
                syncTasks.push(this.syncTaskDetails(task));
            }
        });

        //更新同步任务为即时同步任务
        realTimeTasks.forEach(task => {
            let taskIndex;
            if(task.groupId){
                //如果是多目标任务，则尝试获取在syncGroupIds键值对中的值
                taskIndex = syncGroupIds[task.groupId];
                if(taskIndex != undefined) {
                    //如果已存在该组任务，则添加到对应任务中
                    let groupTask = syncTasks[taskIndex];
                    //配置是同步任务
                    task.type = 2;
                    task.branchType = 'realtime';
                    groupTask.runCount = task.runCount;
                    groupTask.branchType = 'realtime';
                    syncTasks[taskIndex] = groupTask;
                    if(groupTask.id == task.id) {
                        groupTask.status = task.status;
                        groupTask.result = task.result;
                    }else if(groupTask.sources) {
                        for (let i = 0; i < groupTask.sources.length; i++) {
                            if(groupTask.sources[index].id == task.id) {
                                groupTask.sources[index].status = task.status;
                                groupTask.sources[index].result = task.result;
                                break;
                            }
                        }
                    }
                }
            }else {
                //如果是普通任务，则尝试根据id获取
                taskIndex = syncTasks.findIndex(item => item.id == task.id);
                if(taskIndex != undefined) {
                    task.branchType = 'realtime';
                    let newTask = this.syncTaskDetails(task);
                    newTask.branchType = 'realtime';
                    syncTasks[taskIndex] = newTask;
                }
            }
        });

        //计算组任务
        if(syncGroupIds) {
            var keys = Object.keys(syncGroupIds);
            keys.forEach(key => {
                let taskIndex = syncGroupIds[key];
                let task = syncTasks[taskIndex];
                let newTask = this.syncTaskDetails(task);
                //添加首任务id为第一个任务id
                newTask.firstId = task.id;
                newTask.firstStatus = task.status;
                newTask.runCount = task.runCount;
                newTask.branchType = task.branchType;
                newTask.toItem = task.toItem;
                newTask.sources = task.sources;
                syncTasks[taskIndex] = newTask;
            });
        }

        return syncTasks;
    },
    //处理备份还原任务原始集合
    getBackupTasks(originBackupTasks) {
        let backupTasks = [];
        for(let j=0;j<originBackupTasks.length;j++){
            //配置是备份任务
            originBackupTasks[j].type = 6;
            let backupItem = this.backupTaskDetails(originBackupTasks[j]);
            backupTasks.push(backupItem);
        }
        return backupTasks;
    },
    //处理离线任务原始集合
    getOfflinesTasks(originOfflinesTasks) {
        let offlinesTasks = [];
        let offlinesGroupIds = {};//多目标任务id和对应的index
        originOfflinesTasks.forEach(task => {
            if(task.groupId){
                //如果是多目标任务，则尝试获取在offlinesGroupIds键值对中的值
                let taskIndex = offlinesGroupIds[task.groupId];
                if(taskIndex != undefined) {
                    //如果已存在该组任务，则添加到对应任务中
                    let groupTask = offlinesTasks[taskIndex];
                    //添加多目标参数
                    if(task.toItem){
                        groupTask.toItem = this.convertFromOrToSource(groupTask.toItem,task.toItem);
                    }
                    //判断状态用，可删除
                    if(groupTask.sources) {
                        groupTask.sources.push(task);
                    }else {
                        groupTask.sources = [task];
                    }
                    offlinesTasks[taskIndex] = groupTask;
                }else {
                    //如果当前没有该组任务，则新增
                    let newTask = this.offlinesTaskDetails(task);
                    //添加组任务标记
                    taskIndex = offlinesTasks.length;
                    offlinesGroupIds[task.groupId] = taskIndex;
                    offlinesTasks.push(newTask);
                }
            }else {
                //新增单源传输任务
                offlinesTasks.push(this.offlinesTaskDetails(task));
            }
        });
        return offlinesTasks;
    },
    //初始化任务列表数据
    initTaskList(taskListData, callback) {
        //可以添加同时请求限制,及失败重试次数限制
        //获取后端返回的数据
        let that = this;
        requestUtils.doTasksRequest("all_list", taskListData).then(
            res => {
                that.retryTime = 0;
                //报错则终止
                if(res.status == 400){
                    callback(res);
                    return;
                }

                //处理返回的任务数据
                let originArr = [];
                let originBusinessTasks = res[0].tasks;
                let originTransferTasks = res[1].tasks;
                let originBackupTasks = res[2].tasks;
                let realTimeTasks = res[3].tasks;
                let originSyncTasks = res[4].tasks;
                let originOfflinesTasks = res[5].tasks;

                //传输任务标准化数据
                let transferTasks = this.getTransferTasks(originTransferTasks);
                
                //企业传输任务标准化数据
                let businessTasks = this.getBusinessTasks(originBusinessTasks);
                
                //同步任务标准化数据
                let syncTasks = this.getSyncTasks(originSyncTasks,realTimeTasks);
                
                //备份任务添加类型
                var backupTasks = this.getBackupTasks(originBackupTasks);
                
                //离线下载任务添加源数据
                let offlinesTasks = this.getOfflinesTasks(originOfflinesTasks);
                
                let allNotGropArr = originArr.concat(transferTasks).concat(syncTasks).concat(backupTasks).concat(businessTasks).concat(offlinesTasks);

                //任务排序
                allNotGropArr.sort(taskListUtils.sortCreateTime);
                console.log(allNotGropArr);

                callback(allNotGropArr);
            },
            err => {
                setTimeout(()=>{
                    delete taskListData.s;
                    that.retryTime = that.retryTime + 1;
                    if( that.retryTime <= 6){
                        that.initTaskList(taskListData, callback);//如果后端报错，则重试请求
                    }
                },2000);
            }
        );
    },
    //初始化任务
    initNewTask(tasks) {
        let arr;
        if (Array.isArray(tasks)) {
            // tasks 是数组
            arr = tasks;
        }else {
            // tasks 是对象
            arr = [tasks];
        }
        let type;
        let branchType;
        if(arr.length>0) {
            type = arr[0].type;
            if(arr[0].branchType) {
                branchType = arr[0].branchType;
            }
        }
        let reTasks;
        switch (type) {
            case 2:
                // 同步
                if(branchType&&branchType=="realtime") {
                    // 即时同步
                    reTasks = this.getSyncTasks(arr,arr);
                }else {
                    reTasks = this.getSyncTasks(arr,[]);
                }
                break;
            case 3:
                // 离线http
                reTasks = this.getOfflinesTasks(arr);
                break;
            case 5:
                // 离线种子
                reTasks = this.getOfflinesTasks(arr);
                break;
            case 6:
                // 备份
                reTasks = this.getBackupTasks(arr);
                break;
            default:
                // 默认传输
                if(branchType&&branchType=="businessTransfer") {
                    // 企业传输
                    reTasks = this.getBusinessTasks(arr);
                }else {
                    reTasks = this.getTransferTasks(arr);
                }
                break;
        }
        return reTasks;
    },
    //标准化任务状态信息
    convertStatus(task) {
        /*  status类型:
            0: 关闭状态(成功,失败,部分成功,关闭,暂停) -- 默认值
            1: 运行状态(正常运行,遍历数据中,即时同步中)
            2: 等待状态
        */
        var status = 0;
        
        //判断任务的运行状态
        if(taskListUtils.showTransferRunning(task) || taskListUtils.showSyncSingleRunning(task) || taskListUtils.showSyncSourceRunning(task) || taskListUtils.showBackupRunning(task) || ((task.type==3||task.type==5)&&(task.result=='Running' || task.result=='Download No Response'))) {
            status = 1;
        }

        //判断任务的等待状态
        if(taskListUtils.showSyncSingleWaiting(task) || taskListUtils.showTransferWaiting(task) || taskListUtils.showSyncSourceWaiting(task) || taskListUtils.showBackupWaiting(task) || ((task.type==3||task.type==5)&&(task.result=='Waiting' || task.result=='Waiting.pro'))) {
            status = 2;
        }

        return status;
    },
    //标准化任务状态信息
    convertResult(task) {
        /*  result类型:
            -1: 失败
            0: 关闭,暂停(即时同步)
            1: 成功
            2: 部分成功
        */
        var result;

        //判断任务的关闭状态
        if(taskListUtils.showCancelStatus(task) || task.cancelStatus || (!task.status&&task.response=='cancel') || (task.branchType=='realtime'&&(task.status=='InitStop'||task.status=='Stop'||task.status=='TimeoutStop'||task.status=='Cancel'))) {
            result = 0;
        }else {
            //非关闭状态详情
            if (!task.isMultiTask) {
                if (taskListUtils.showFailStatus(task)||task.result=='Error'||task.result=='error'||task.response=='error') {
                    result = -1;
                }else if (taskListUtils.showpartialStatus(task)|| task.result== "Partial Success") {
                    result = 2;
                }else if (taskListUtils.showSuccessStatus(task)||task.result=='Success'||task.response=='success') {
                    result = 1;
                }
            }else {
                //多源或多目标
                if (taskListUtils.showSourcesFailureStatus(task)) {
                    result = -1;
                }else if (taskListUtils.showSourcepartialStatus(task)) {
                    result = 2;
                }else if (taskListUtils.showSourceSuccessStatus(task)) {
                    result = 1;
                }
            }
        }

        return result;
    },
    //tasks获取任务状态信息
    convertResultByTasks(tasks) {
        if(tasks.length>1) {
            var task = tasks[0];
            task.sources = [];
            for (let i = 1; i < tasks.length; i++) {
                task.sources.push(tasks[i]);
            }
            return this.convertResult(task);
        }else {
            return this.convertResult(tasks[0]);
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/workspace/task_list_convert.js